export default __webpack_public_path__ + "static/media/metamask-fox.386c9d10.svg";